import React from 'react';

export default function CheckoutModal({ player, onConfirm, onClose, loading }) {
  const { name, finalBalance, initialBalance, profit } = player;
  const profitSign = profit >= 0 ? '+' : '';
  const profitClass = profit >= 0 ? 'checkout-profit-pos' : 'checkout-profit-neg';

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-panel" onClick={e => e.stopPropagation()}>
        <h3 className="modal-title">AUSZAHLUNG</h3>
        <p className="checkout-player-name">{name}</p>
        <table className="checkout-table">
          <tbody>
            <tr>
              <td className="checkout-td-label">Eingecheckt mit</td>
              <td className="checkout-td-value">{initialBalance} Chips</td>
            </tr>
            <tr>
              <td className="checkout-td-label">Aktuelles Guthaben</td>
              <td className="checkout-td-value">{finalBalance} Chips</td>
            </tr>
            <tr className="checkout-divider-row">
              <td colSpan={2}><div className="checkout-divider" /></td>
            </tr>
            <tr>
              <td className="checkout-td-label">Gewinn / Verlust</td>
              <td className={`checkout-td-value ${profitClass}`}>
                {profitSign}{profit} Chips
              </td>
            </tr>
          </tbody>
        </table>
        <div className="checkin-actions">
          <button className="modal-btn-secondary" onClick={onClose} disabled={loading}>
            ABBRECHEN
          </button>
          <button className="modal-btn-payout" onClick={onConfirm} disabled={loading}>
            {loading ? '...' : `${finalBalance} AUSZAHLEN`}
          </button>
        </div>
      </div>
    </div>
  );
}
